import { writable } from 'svelte/store';
import type { Schema } from './index';

const { subscribe, set, update } = writable<Schema.Type[]>([]);

export const locationsStore = {
  subscribe,
  setLocations: (locations: Schema.Type[] | undefined | null) => set(locations || []),
  updateLocations: (updateFn: (locations: Schema.Type[]) => Schema.Type[]) => update(updateFn),
  reset: () => set([])
};
